import { useIonViewWillEnter } from '@ionic/react';
import { useQueryClient, type QueryKey } from '@tanstack/react-query';

/**
 * Ionic `IonTabs` keep pages mounted, so React Query `refetchOnMount` never
 * runs when switching back to a tab. Capacitor tab switches also skip window
 * focus. Invalidate on `ionViewWillEnter` so active queries refetch without
 * remounting the page.
 */
export function useInvalidateOnIonViewEnter(
  queryKeys: readonly QueryKey[],
): void {
  const queryClient = useQueryClient();

  useIonViewWillEnter(() => {
    for (const queryKey of queryKeys) {
      void queryClient.invalidateQueries({ queryKey });
    }
  });
}
